const main_search_page = document.getElementById('main-search-page');
let productCount = 0;
let easyrepairCount = 0;

function formatListCardDesc(text) {
  if (!text) {
    return '';
  }

  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\r?\n/g, '<br>');
}

document.addEventListener('DOMContentLoaded', async() => {
  // 검색 데이터
  try {
    await allSearcDataLoaded;
  }
  catch (error) {
    console.error("Error loading data:", error);
  }

  // 검색 
  handleSearch();

  // 배너 CSS
  document.querySelector('.section-recommend').classList.add('no-result-recommend');

  // 배너 링크 연결
  let searchBanner = document.querySelector('.main-search ~ .list-guide-banner .guide-banner-container');
  if(searchBanner) {
    searchBanner.style.cursor = "pointer";
    searchBanner.addEventListener('click', () => {
      location.href="/pages/easy-repair";
    });
  }

  mainSearchCss();
  observeTabAll();

  handleMainSearchInputDeleteBtn();
  if(main_search_page.querySelector('.input-container input').value.trim() != '') {
    main_search_page.querySelector('.main-search-delete').classList.remove('hidden');
  }

  handleMainInputSearch();
  handleInputModal();
  recentSearchMainMouse();
  showPopularContentSearch();
  recommendPopularContent();

  // 최근 검색어
  let savedSearchesMain = JSON.parse(sessionStorage.getItem('recentSearches'));
  if (savedSearchesMain) {
    displayRecentSearchesMain(savedSearchesMain);
  }

  // let searchInputMain = document.getElementById('search-form-sidebar');
  let searchInputMain = document.getElementById('main-search-page-input');
  let searchTermMain = searchInputMain.value.trim();

  if (searchTermMain) {
    // 세션 스토리지에서 최근 검색어 목록 가져오기
    let recentSearchesMain = JSON.parse(sessionStorage.getItem('recentSearches')) || [];

    // 중복된 검색어 제거
    recentSearchesMain = recentSearchesMain.filter((item) => item !== searchTermMain);

    // 최근 검색어 목록에 추가 (최신 검색어가 맨 앞에 오도록)
    recentSearchesMain.unshift(searchTermMain);

    // 최대 저장할 검색어 개수 제한 (예: 10개)
    if (recentSearchesMain.length > 10) {
      recentSearchesMain.pop();
    }

    // 세션 스토리지에 저장
    sessionStorage.setItem('recentSearches', JSON.stringify(recentSearchesMain));

    // 최근 검색어 화면에 표시
    displayRecentSearchesMain(recentSearchesMain);
  }
  setProductThumbnail();
  handleMainSearchTab();
  setProductThumbnail();

  addClickSearchEvent();

  viewSearchResult();
});

// PLUS ZERO: view_search_result
function viewSearchResult() {
  const searchType = sessionStorage.getItem('searchType');
  sessionStorage.removeItem('searchType');
  if(searchType) {
    document.querySelector('#main-search-page').dataset.searchType = searchType;

    // 검색어가 없을 경우
    let searchResult = 'N';
    if(productCount + easyrepairCount > 0) {
      searchResult = 'Y';
    }
    
    window.dataLayer.push({
      event: 'view_search_result',
      page_type: '검색',
      search_type: searchType,
      search_term: document.getElementById('main-search-page-input').value || '_',
      search_result: searchResult
    });
  }
}

// CSS
function mainSearchCss() {

  // wrapper--image를 main-search-wrapper--image로 변경
  main_search_page.querySelectorAll('.wrapper--image').forEach(element => {
    element.classList.remove('wrapper--image');
    element.classList.add('main-search-wrapper--image');
  });

  // body--product 클래스 제거
  main_search_page.querySelectorAll('.body--product').forEach(element => {
    element.classList.remove('body--product');
  });
}

// 전체탭 이지리페어 모바일 UI
function observeTabAll() {
  const targetTab = document.querySelector('#main-search-page .guide-category-item[data-tab="all"]');
  let mobileEasyRepair = document.querySelector('#main-search-page .main-search-easyrepair-grid');

  const tabObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class' && mobileEasyRepair) {
        if(targetTab.className.includes('category-active')) {
          mobileEasyRepair.classList.add('easyrepair-mobile');
        }
        else {
          mobileEasyRepair.classList.remove('easyrepair-mobile');
        }
      }
    });
  });

  tabObserver.observe(targetTab, {
    attributes: true, 
    attributeFilter: ['class'], 
  });
}

// 인풋 지우기
function handleMainSearchInputDeleteBtn() {

  let mainInput = main_search_page.querySelector('.input-container input');
  let mainDeleteBtn = main_search_page.querySelector('.main-search-delete');

  // 인풋 텍스트 지우기 버튼 상태
  mainInput.addEventListener('input', () => {
    if (mainInput.value == '') {
      mainDeleteBtn.classList.add('hidden');
    }
    else {
      mainDeleteBtn.classList.remove('hidden');
    }
  })

  // 인풋 텍스트 지우기
  mainDeleteBtn.addEventListener('click', () => {
    mainInput.value = '';
    mainDeleteBtn.classList.add('hidden');
  });
}

// 인풋 검색
function handleMainInputSearch() {

  let mainSearchForm = main_search_page.querySelector('.search-page-form form');
  let mainSearchInput = main_search_page.querySelector('.search-page-form input');
  let mainInputValue = null;
  
  mainSearchForm.addEventListener('submit', (event) => {

    mainInputValue = mainSearchInput.value.trim();
    
    if(mainInputValue.length < 2) {
      event.preventDefault();
      main_search_page.querySelector('.search-warning').classList.remove('hidden');
      main_search_page.querySelector('.input-bottom').classList.add('hidden');
      return;
    }
    else {
      sessionStorage.setItem('searchType', '직접 검색');
      main_search_page.querySelector('.search-warning').classList.add('hidden');
    }
  })
}

// 인풋 모달
function handleInputModal() {

  let input = main_search_page.querySelector('.search-page-form input#main-search-page-input');
  let inputBottom = main_search_page.querySelector('.input-bottom');
  let deleteBtn = main_search_page.querySelector('.main-search-delete');

  input.addEventListener('focus', () => {
    inputBottom.classList.remove('hidden');
  });

  document.addEventListener('click', (event) => {
    
    if (input.contains(event.target) || deleteBtn.contains(event.target) || inputBottom.contains(event.target)) {
      return;
    }
  
    setTimeout(() => {
      inputBottom.classList.add('hidden');
    }, 100);
  });

  deleteBtn.addEventListener('click', () => {
    input.focus();
  });
}

// 최근 검색어 하나 삭제
function removeSearchTermMain(searchTerm, event) {

  event.stopPropagation();

  let recentSearches = JSON.parse(sessionStorage.getItem('recentSearches')) || [];
  recentSearches = recentSearches.filter((item) => item !== searchTerm);

  if(recentSearches.length <= 0) {
    main_search_page.querySelector('.input-recent_wrap').classList.add('hidden');
  }
  else {
    main_search_page.querySelector('.input-recent_wrap').classList.remove('hidden');
  }

  sessionStorage.setItem('recentSearches', JSON.stringify(recentSearches));
  displayRecentSearchesMain(recentSearches);
}

// 최근 검색어 전체 삭제
function removeAllSearchTermMain() {
  sessionStorage.setItem('recentSearches', JSON.stringify([]));
  main_search_page.querySelector('.input-recent_wrap').classList.add('hidden');
  displayRecentSearchesMain([]);
}

// 최근 검색어 뿌리기
function displayRecentSearchesMain(searches) {

  const searchResultsDiv = main_search_page.querySelector('.input-label_list');

  if(searches.length <= 0) {
    main_search_page.querySelector('.input-recent_wrap').classList.add('hidden');
    searchResultsDiv.innerHTML = '';
    let noSearches = `
      <div style="font-size: 13px; line-height: 120%; letter-spacing: -0.26px;">
        최근 검색어가 없습니다.
      </div>`;
    searchResultsDiv.insertAdjacentHTML('afterbegin', noSearches);
    return;
  }
  else {
    main_search_page.querySelector('.input-recent_wrap').classList.remove('hidden');
  }

  searchResultsDiv.innerHTML = '';
  searches.forEach((search) => {
    const div = document.createElement('div');
    div.className = 'input-label_item';
    div.onclick = () => {
      sessionStorage.setItem('searchType', '최근 검색어');
      location.href = `/search?sort_by=relevance&q=${search}`;
    };
    div.innerHTML = `
      ${search}
      <div class="input-close_btn" onclick="removeSearchTermMain('${search}', event)">
        <img src="${icon_close_line_bk}" alt="최근 검색어 삭제 버튼">
      </div>
    `;
    searchResultsDiv.appendChild(div);
  });
}

// 최근 검색어 마우스 드래그
function recentSearchMainMouse() {

  let label_container = main_search_page.querySelector('.input-recent_wrap .input-label_list');
  let label_item = label_container.querySelectorAll('.input-label_item');
  
  let isDragging = false;
  let startX;
  let scrollLeft;
  let dragDistance = 0;

  // 마우스 누르기 시작
  label_container.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - label_container.offsetLeft;
    scrollLeft = label_container.scrollLeft;
    dragDistance = 0;
  });

  // 마우스 움직이기
  label_container.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - label_container.offsetLeft;
    const walk = (x - startX) * 1.5;
    label_container.scrollLeft = scrollLeft - walk;
    dragDistance += Math.abs(walk);
  });

  // 마우스 떼기
  label_container.addEventListener('mouseup', (e) => {
    isDragging = false;
    if (dragDistance > 5) {
      e.preventDefault();
    }
  });

  // 마우스 영역 벗어나기
  label_container.addEventListener('mouseleave', () => {
    isDragging = false;
  });
}

// 가장 인기있는 혜택과 콘텐츠 
function showPopularContentSearch() {

  let contentList = JSON.parse(tempList);
  contentList = contentList.sort((a, b) => a.rank - b.rank);

  let popularContentWrap = main_search_page.querySelector('.input-popular-content_wrap');
  let titleWrap = popularContentWrap.querySelector('.input-title_wrap');

  if(contentList && contentList.length > 0) {

    Array.from(popularContentWrap.children).forEach(child => {
      if (child != titleWrap) {
        popularContentWrap.removeChild(child);
      }
    });

    for (let i = 0; i < contentList.length; i++) {
      let temp = `
        <div class="input-content_item">
          <span>${i + 1}</span>
          <a href="${contentList[i].url}">${contentList[i].title_text}</a>
        </div>`;
      
      popularContentWrap.insertAdjacentHTML('beforeend', temp);
    }
  }
  else {
    Array.from(popularContentWrap.children).forEach(child => {
      if (child != titleWrap) {
        popularContentWrap.removeChild(child);
      }
    });

    let temp = `
      <div style="font-size: 13px; line-height: 120%; letter-spacing: -0.26px;">
        가장 인기있는 혜택과 콘텐츠가 없습니다.
      </div>`;
    popularContentWrap.insertAdjacentHTML('beforeend', temp);
  }
}

// 검색 결과 없을시 이 소식은 어떠신가요
function recommendPopularContent() {

  let newsList = JSON.parse(tempNewsList);
  newsList = newsList.sort((a, b) => a.rank - b.rank);

  let noNewsList = document.querySelector('#main-search-page .main-search-no-news-list');

  if(noNewsList) {
    if(newsList && newsList.length > 0) {
      noNewsList.replaceChildren();
  
      for (let i = 0; i < newsList.length; i++) {
        let temp = `
          <div>
            <a href="${newsList[i].url}">${newsList[i].title_text}</a>
          </div>`;
        noNewsList.insertAdjacentHTML('beforeend', temp);
      }
    }
    else {
      noNewsList.replaceChildren();
    }
  }
}

// 탭
function handleMainSearchTab() {

  let divideLine = document.querySelector('.divide-line');
  // let productBlock = document.querySelector('.main-search-block.product-block');
  // let easyrepairBlock = document.querySelector('.main-search-block.easyrepair-block');
  let productBlock = document.querySelector('main-search-product');
  let easyrepairBlock = document.querySelector('main-search-easyrepair');
  let tabList = document.querySelectorAll('#main-search-page .guide-category-item');

  tabList.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabList.forEach((list) => list.classList.remove('category-active'));
      tab.classList.add('category-active');

      let type = tab.dataset.tab;

      if(type == "all") {
        productBlock.classList.remove('hidden');
        easyrepairBlock.classList.remove('hidden');
        divideLine.classList.remove('hidden');
      }
      else if(type == "product") {
        productBlock.classList.remove('hidden');
        easyrepairBlock.classList.add('hidden');
        divideLine.classList.add('hidden');
      }
      else if(type == "easy-repair") {
        productBlock.classList.add('hidden');
        easyrepairBlock.classList.remove('hidden');
        divideLine.classList.add('hidden');
      }
    })
  })

  let tabAllBtn = document.querySelector('#main-search-page .guide-category-item[data-tab="all"]');
  let tabProductBtn = document.querySelector('#main-search-page .guide-category-item[data-tab="product"]');
  let tabEasyrepairBtn = document.querySelector('#main-search-page .guide-category-item[data-tab="easy-repair"]');
  
  tabAll();

  tabAllBtn.addEventListener('click', tabAll);
  tabProductBtn.addEventListener('click', tabProduct);
  if(easyrepairCount != 0) {
    tabEasyrepairBtn.addEventListener('click', tabEasyrepair);
  }
}

// 전체 검색결과
function tabAll() {
  // 제품
  if(productCount != 0) {
    document.getElementById('productObserverTarget').classList.add('hidden');
    let productList = document.querySelectorAll('#main-search-page .main-search-grid .content--product[data-index]');
    let productListAllBtn = document.querySelector('#main-search-page .main-search-show-all.all-product');

    productList.forEach((el) => {
      if(Number(el.dataset.index) > 4) {
        el.classList.add('hidden');
      }
    })

    if(productList.length <= 4) {
      productListAllBtn.classList.add('hidden');
    }
    else {
      productListAllBtn.classList.remove('hidden');

      productListAllBtn.addEventListener('click', () => {
        for (let i = 4; i < productList.length; i++) {
          productList[i].classList.remove('hidden');
        }
        productListAllBtn.classList.add('hidden');
      })
    }
  }
  else {
    let productListAllBtn = document.querySelector('#main-search-page .main-search-show-all.all-product');
    if(productListAllBtn) {
      productListAllBtn.classList.add('hidden');
      document.getElementById('productObserverTarget').classList.add('hidden');
    }
  }
  
  // 이지리페어
  if(easyrepairCount != 0) {
    document.getElementById('easyrepairObserverTarget').classList.add('hidden');
    let easyrepairList = document.querySelectorAll('#main-search-page .main-search-easyrepair-grid .content--product[data-index]');
    let easyrepairListAllBtn = document.querySelector('#main-search-page .main-search-show-all.all-easyrepair');
    let easyrepairListMobile = document.querySelector('#main-search-page .main-search-easyrepair-grid.easyrepair-mobile');

    easyrepairList.forEach((el) => {
      if(Number(el.dataset.index) > 6) {
        el.classList.add('hidden');
      }
    })

    if(easyrepairList.length <= 6) {
      easyrepairListAllBtn.classList.add('hidden');
    }
    else {
      easyrepairListAllBtn.classList.remove('hidden');

      easyrepairListAllBtn.addEventListener('click', () => {
        for (let i = 6; i < easyrepairList.length; i++) {
          easyrepairList[i].classList.remove('hidden');
        }
        easyrepairListAllBtn.classList.add('hidden');
        easyrepairListMobile.classList.remove('easyrepair-mobile');
      })
    }
  }
  else {
    let easyrepairListAllBtn = document.querySelector('#main-search-page .main-search-show-all.all-easyrepair');
    if(easyrepairListAllBtn) {
      easyrepairListAllBtn.classList.add('hidden');
      document.getElementById('easyrepairObserverTarget').classList.add('hidden');
    }
  }
}

// 제품탭
function tabProduct() {

  document.querySelector('#main-search-page .main-search-show-all.all-product').classList.add('hidden');
  const productObserverTarget = document.getElementById('productObserverTarget');
  productObserverTarget.classList.remove('hidden');

  const productPerPage = 8;
  let productCurrentIndex = productPerPage;
  let productList = document.querySelectorAll('#main-search-page .main-search-grid .content--product[data-index]');
  
  productList.forEach((el) => {
    if(Number(el.dataset.index) > productPerPage) {
      el.classList.add('hidden');
    }
    else {
      el.classList.remove('hidden');
    }
  })

  const productObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {

      for (let i = productCurrentIndex; i < productCurrentIndex + productPerPage; i++) {
        if (productList[i]) {
          productList[i].classList.remove('hidden');
        }
      }
      productCurrentIndex += productPerPage;

      if (productCurrentIndex > productCount) {
        productObserver.unobserve(productObserverTarget);
        productObserverTarget.classList.add('hidden');
      }
    }
  }, { threshold: 0.3 });

  productObserver.observe(productObserverTarget);
}

// 이지리페어탭
function tabEasyrepair() {

  document.querySelector('#main-search-page .main-search-show-all.all-easyrepair').classList.add('hidden');
  const easyrepairObserverTarget = document.getElementById('easyrepairObserverTarget');
  easyrepairObserverTarget.classList.remove('hidden');

  const easyrepairPerPage = 12;
  let easyrepairCurrentIndex = easyrepairPerPage;
  let easyrepairList = document.querySelectorAll('#main-search-page .main-search-easyrepair-grid .content--product[data-index]');
  
  easyrepairList.forEach((el) => {
    if(Number(el.dataset.index) > easyrepairPerPage) {
      el.classList.add('hidden');
    }
    else {
      el.classList.remove('hidden');
    }
  })

  const easyrepairObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {

      for (let i = easyrepairCurrentIndex; i < easyrepairCurrentIndex + easyrepairPerPage; i++) {
        if (easyrepairList[i]) {
          easyrepairList[i].classList.remove('hidden');
        }
      }
      easyrepairCurrentIndex += easyrepairPerPage;

      if (easyrepairCurrentIndex > easyrepairCount) {
        easyrepairObserver.unobserve(easyrepairObserverTarget);
        easyrepairObserverTarget.classList.add('hidden');
      }
    }
  }, { threshold: 0.3 });

  easyrepairObserver.observe(easyrepairObserverTarget);
}

function setProductThumbnail() {
  let products = document.querySelectorAll('#main-search-page .content--product');

  products.forEach(product => {
    let colorchips = product.querySelectorAll('.colorchip');

    colorchips.forEach((colorchip, idx) => {
      colorchip.addEventListener('click', () => {
        colorchips.forEach(el => el.classList.remove('selected'));
        colorchip.classList.add('selected');
        let images = product.querySelectorAll('.image--product');

        images.forEach(image => {
          image.classList.remove('selected');
          if(image.dataset.id == colorchip.dataset.id) {
            image.classList.add('selected');
          }
        });
      });
    });
  });
}

// 검색 수정
function handleSearch() {

  // allSearchData 비노출 컬렉션 필터링
  allSearchData = allSearchData.filter((data) => {
    return !data.collections.some((collection) => 
      collection.title.includes("비노출 컬렉션") || collection.title.includes("임직원 특별 프로모션")
    );
  });

  // 추천 상품 + 배너
  let recommendSection = document.querySelector('.section-recommend');
  let searchBanner = document.querySelector('.guide-banner-container');
  let mainSearchTab = document.querySelector('#main-search-page .list-guide-content-bottom');

  if(!allSearchData || allSearchData.length == 0) {
    recommendSection.classList.remove('hidden');
    searchBanner.classList.remove('hidden');
    mainSearchTab.style.pointerEvents = 'none';
    return;
  }
  else {
    recommendSection.classList.add('hidden');
    searchBanner.classList.add('hidden');
    mainSearchTab.style.pointerEvents = 'auto';
  }

  let product_list = [];
  let easyrepair_list = [];

  if(allSearchData && allSearchData.length > 0) {
    allSearchData.forEach((search) => {
      if(search.tags && search.tags.includes('EASY-REPAIR')) {
        easyrepair_list.push(search);
      }
      else {
        product_list.push(search);
      }
    })
  }

  // 카운트
  productCount = product_list.length;
  easyrepairCount = easyrepair_list.length;

  // 상품 그리드
  showMainSearch(product_list, "product");
  showMainSearch(easyrepair_list, "easyrepair");
}

function showMainSearch(product_list, type) {
  let container = null;
  if(type == "product") {
    container = document.querySelector('main-search-product');
  }
  else if(type == "easyrepair") {
    container = document.querySelector('main-search-easyrepair');
  }

  // 검색결과 개수
  container.querySelector('.main-search-type-count').textContent = product_list.length;
  let productContainer = container.querySelector('.showMainSearch');
  let noItem = container.querySelector('.search-no-item');

  if(!product_list || product_list.length == 0) {
    productContainer.classList.add('hidden');
    noItem.classList.remove('hidden');
    return;
  }
  else {    
    productContainer.classList.remove('hidden');
    productContainer.replaceChildren();
    noItem.classList.add('hidden');
  }

  // 품절 정렬
  let withInventory = [];
  let withoutInventory = [];

  for (let product of product_list) {
    let inventory = false;
    for (let variant of product.variants) {
      if (variant.inventory_quantity === undefined || variant.inventory_quantity === null) {
        inventory = true;
        break;
      }
      if (variant.inventory_quantity > 0) {
        inventory = true;
        break;
      }
    }

    product.inventory = inventory;
    if(inventory) {
      withInventory.push(product);
    }
    else {
      withoutInventory.push(product);
    }
  }

  const sorted_product_list = [...withInventory, ...withoutInventory];
  sorted_product_list.forEach((product, index) => {

    // NEW 뱃지
    let currentDate = Math.floor(Date.now() / 1000);
    let publishedDate = Math.floor(new Date(product.published_at).getTime() / 1000);
    let fiveDaysInSeconds = 5 * 24 * 60 * 60;
    let newThreshold = publishedDate + fiveDaysInSeconds;
    
    let variantData = product.variants[0];
    for(let i = 0; i < product.variants.length; i++) {
      if(product.variants[i].price === product.price_min) {
          variantData = product.variants[i];
          break;
      }
    }

    let price_varies = product.price_varies;
    let price = variantData.price;
    let specialPrice = variantData.special_price;
    let eventStartDate = variantData.event_start_dt;
    let eventEndDate = variantData.event_end_dt;
    let customerDiscountRate = 0;
    let isEvent = false;
    let priceTag = "";

    if(eventStartDate && eventEndDate) {
      const now = new Date();
      const start = new Date(eventStartDate);
      const end = new Date(eventEndDate);
      if(now >= start && now <= end) {
        isEvent = true;
      }
    }

    priceTag = `
      <div class="text--price">
        <span class="price--cur">${Number(price).toLocaleString()}원${price_varies == 'true' ? '~' : ''}</span>
      </div>
    `;
    if (isEvent) {
      // 문자열로 처리된 값을 숫자로 변환
      let priceNum = parseFloat(price.replace(/,/g, ""));
      let specialPriceNum = parseFloat(specialPrice.replace(/,/g, ""));
    
      if (priceNum > specialPriceNum) {
        customerDiscountRate = Math.round(
          ((priceNum - specialPriceNum) / priceNum) * 100);
    
        // 결과 강제 정수 변환
        customerDiscountRate = parseInt(customerDiscountRate, 10);
    
        priceTag = `
          <div class="title--discount">회원 할인가</div>
          <div class="text--price">
            <span class="percent--discount">${customerDiscountRate}%</span>
            <span class="price--cur">${specialPriceNum.toLocaleString()}원${price_varies == 'true' ? '~' : ''}</span>
            <div class="price--prev">${priceNum.toLocaleString()}원${price_varies == 'true' ? '~' : ''}</div>
          </div>
        `;
      }
    }

    // 뱃지
    let badgeList = product.badge_list;
    let badge_html = '';
    if(badgeList && badgeList.length > 0) {
      badgeList.forEach(badge => {
        let text_color = badge.text_color || '#000000';
        let background_color = badge.background_color || '#ffffff';
        let border_color = badge.border_color || '#d6dade';

        badge_html += `
          <div class="product-badge" data-badge="${badge.handle}" style="color: ${text_color}; background-color: ${background_color}; border: 1px solid ${border_color};">
            ${badge.text}
          </div>
        `;
      })
    }

    let type_text = '제품';
    if(type == 'easyrepair') {
      type_text = '이지리페어';
    }

    const listCardDesc = formatListCardDesc(product.list_card_desc);

    // 요소
    let temp = `
      <div id="product-${product.id}" class="content--product" data-index="${index + 1}">
        <div class="header--product" data-skulist="">
          <div class="wrapper--image">
            ${(() => {
              let image = '';
              product.variants.forEach((variant, index) => {
                image += `
                  <div class="image--product ${index === 0 ? "selected" : ""}" data-id="${variant.id}">
                    ${variant.featured_image.src_tag}
                  </div>
                `;
              })
              return image;
            })()}
          </div>

          <div class="wrapper--badge">
            ${currentDate < newThreshold ? `<div class="product-badge" data-badge="new">NEW</div>` : ""}
            ${badge_html}
          </div>

          <div class="button--like" data-item-category="${product.category}" data-item-name="${product.title}" data-item-img="${product.variants[0].featured_image.src}">
            <img src="${icon_bookmark_line_bk_28}" alt="북마크 아이콘" width="28" height="28"
                data-bookmark="false" data-id="${product.id}" data-handle="${product.handle}" 
                onclick="addBookmark(event.target)" class="bookmark-false">
            <img src="${icon_bookmark_blue}" alt="북마크 아이콘" width="28" height="28"
                data-bookmark="true" data-id="${product.id}" data-handle="${product.handle}" 
                onclick="removeBookmark(event.target)" class="bookmark-true hidden"> 
          </div>
          <a href="${product.url}" data-product-type="${type_text}"></a>
      </div>

      <div class="body--product">
          <div class="title--product"><a href="${product.url}">${product.title}</a></div>
          <div class="price--product">
            ${priceTag}
          </div>
          <div class="color--product">
            ${(() => {
              let color = '';
              product.variants.forEach((variant, index) => {
                color += `
                  <div class="colorchip ${index === 0 ? "selected" : ""}" data-id="${variant.id}">
                    <div class="color" style="background-color: ${variant.color_rgb};"></div>
                  </div>
                `;
              })
              return color;
            })()}
          </div>
          ${product.inventory ? '' : '<div class="inventory--product">일시품절</div>'}
          ${listCardDesc ? `<div class="description--product">${listCardDesc}</div>` : ''}
        </div>
      </div>
    `;

    productContainer.insertAdjacentHTML("beforeend", temp);
  })
}

function addClickSearchEvent() {
  const contentProduct = document.querySelectorAll('.content--product');
  
  if(contentProduct.length > 0) {
    contentProduct.forEach(product => {
      product.querySelectorAll('a').forEach(aTag => {
        aTag.addEventListener('click', () => {
          let searchType = document.querySelector('#main-search-page').dataset.searchType || '직접 검색';
          let searchTerm = document.getElementById('main-search-page-input').value;
          let clickType = aTag.dataset.productType;
          let clickText = product.querySelector('.title--product a').innerText;
          let clickUrl = product.querySelector('.title--product a').href;
    
          window.dataLayer.push({
            event: 'click_search_result',
            page_type: window.pageType,
            search_type: searchType,
            search_term: searchTerm,
            click_type: clickType,
            click_text: clickText,
            click_url: clickUrl
          });
        });
      });
    });
  }
}
